import { getRoute } from "../client"
import type { StudyType } from "../../shared/types"

interface ProfileDto {
  userName: string
  userCity: string
  gender: "male" | "female"
  characterKey: string
  hairKey: string
  clothesKey: string
  skinColor: string
  hairColor: string
  clothesColor: string
  studyType: StudyType | null
  studyValue: string
}

export const getProfileRoute = getRoute<{ profile: ProfileDto | null; coins: number }>("/api/profile")
